import { render, staticRenderFns } from "./SlglrsPG2010_OverviewPage.vue?vue&type=template&id=4f60ac7d&"
import script from "./SlglrsPG2010_OverviewPage.vue?vue&type=script&lang=js&"
export * from "./SlglrsPG2010_OverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./SlglrsPG2010_OverviewPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports